import { useEffect } from "react"
import { setDefaultOptions } from "date-fns"
import { dateFnsLocale } from "@/modules/calendar/config/date-fns-config"

export default function DateFnsProvider() {
  useEffect(() => {
    setDefaultOptions({ locale: dateFnsLocale })
  }, [])

  return null
}
